import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TIKTOK_READY_EVENT, trackTikTokPage } from '../utils/tiktokPixel';
export default function TikTokPageViewTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const track = () => trackTikTokPage(`${pathname}${search}`);
    window.addEventListener(TIKTOK_READY_EVENT, track); track();
    return () => window.removeEventListener(TIKTOK_READY_EVENT, track);
  }, [pathname, search]);
  return null;
}
